module.exports = __webpack_public_path__ + "img/Overdue ticket.99849f20.png";